import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.prototype.$http = axios    //全局注册，使用方法为:this.$axios

//引入echarts
import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)

// 引入标签云组件，展示标签
import tagCloud from 'v-tag-cloud'
Vue.use(tagCloud)

// 引入文字打印效果
import VueTypedJs from 'vue-typed-js';
Vue.use(VueTypedJs)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
